// store 
import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';

// state
import { AppState } from '../../../redux/reducers';

// models
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { ProtocolConsumptionTotal } from '../../../models/Entities/Protocols/ProtocolConsumptionTotal';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';


//#region Props

interface IProps {
    ProtocolId: number;
    status: number;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    error: string | null;
    Totals: ProtocolConsumptionTotal[];
    protocol: Protocol | null;
    NeedUpdating: boolean;
}

interface MedicalServicesDispatchProps {
    GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
    GetTotalsByStatus: typeof ProtocolConsumptionStore.ActionCreators.GetTotalsByStatus;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const AuxProtocol: Protocol | null =  state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) || null;

    const AuxNeedUpdating: boolean = 
    AuxProtocol?.isGettingConsumptions 
    || AuxProtocol?.consumptions?.some((consumption: ProtocolConsumption) => consumption.amountChanged || consumption.statusChanged || consumption.visitTypeChanged) || false;

    return {
        isLoading: state.MedicalProtocols?.isLoadingAllConsumptions || false,
        successLoading: state.MedicalProtocols?.LoadingAllConsumptionsSuccess || undefined,
        error: state.MedicalProtocols?.ErrorGettingAllConsumptions || null,
        Totals: AuxProtocol?.AmountTotals?.filter((total: ProtocolConsumptionTotal) => total.status === ownProps.status) || [],
        protocol: AuxProtocol,
        NeedUpdating: AuxNeedUpdating,
    }
};

export const mapDispatchToProps = {
    ...ProtocolsStore.actionCreators,
    ...ProtocolConsumptionStore.ActionCreators,
};


export const GetStatusDescription = (status: number) => {

    /*
        NotSettled = 0,
        Pending = 1,
        Payee = 2,
        Settled = 3,
        Rejected = 4,
        Ignored = 5,
        ToSettle = 6
     */

    switch (status) {
        case 0:
            return 'Pendiente de liquidación';
        case 1:
            return 'Con saldo pendiente';
        case 2:
            return 'Pagado';
        case 3:
            return 'Liquidado';
        case 4:
            return 'Rechazado';
        case 5:
            return 'Ignorado';
        case 6:
            return 'Para liquidar';
        default:
            return 'Unknown';
    }
}

export function GetStatusClass (status: number): string {
    switch (status) {
        case 0:
            return 'statusTotal-not-settled';
        case 1:
            return 'statusTotal-pending';
        case 2:
            return 'statusTotal-payee';
        case 3:
            return 'statusTotal-settled';
        case 4:
            return 'statusTotal-rejected';
        case 5:
            return 'statusTotal-ignored';
        case 6:
            return 'statusTotal-to-settle';
        default:
            return 'statusTotal-unknown';
    }
}